<template>
  <!--
  ==========================================================================
  General
  ==========================================================================
  -->
  <form class="h-100 scrollable padded">
    <string-form-field
      :label="$t('tag.fields.label')"
      required
      :value="value.label"
      :disabled="disabled"
      :error="findError('label')"
      @input="propertyChange('label', $event)"
    />
  </form>
</template>
<script>
import EditorMixin from "vue-template/common/mixins/EditorMixin";
import ErrorCounterMixin from "vue-forms/mixins/ErrorCounterMixin";

export default {
  mixins: [EditorMixin, ErrorCounterMixin]
};
</script>
